import { ExternalLink } from './ExternalLink';

import type { ActionCardSourceLink } from '@littlebird/action-cards';

export const ActionCardSourceLinkAnchor = ({
  sourceLink,
}: {
  sourceLink: ActionCardSourceLink;
}) => (
  <ExternalLink
    href={sourceLink.href}
    className="shrink-0 text-xs text-foreground-muted"
  >
    {sourceLink.label}
  </ExternalLink>
);
